import { LinkApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import useOnLoad from '~/routes/use-on-load';
import { useState } from 'react';
import OrderPudoCodes, { ItemPudoCodes } from './PudoCodes';

interface props {
  item: SmartSendItemApiModel;
  actions?: LinkApiModel[];
  wrapper: (content: React.ReactNode) => React.ReactElement;
  displayMode?: 'list' | 'full';
}

const IsPrintInStoreStatusLink = (link: LinkApiModel) => link.Type === 'PUDO-STATUS';

const PudoCodesAutoLoad = ({ item, wrapper, actions, displayMode }: props) => {
  const { getPrintInStoreLinks } = useSmartSendApi();
  const [pudoLink, setPudoLink] = useState<string>(null);

  useOnLoad(() => {
    const fetchLinks = async () => {
      const res = await getPrintInStoreLinks(
        item.Service.Provider,
        item.Service.AccountId,
        item.BookingDetails.OrderLineId
      );

      if (res.success && res.result?.Links?.length) {
        setPudoLink(res.result.Links.find((x) => IsPrintInStoreStatusLink(x))?.Href);
      }
    };

    // If we already have actions passed in, use those to get the links, otherwise fetch them
    if (actions?.some((x) => IsPrintInStoreStatusLink(x))) {
      setPudoLink(actions.find((x) => IsPrintInStoreStatusLink(x)).Href);
    } else {
      if (item.Service && item.BookingDetails?.OrderLineId) {
        fetchLinks();
      }
    }
  });

  if (!pudoLink) {
    return null;
  }

  return item ? (
    <ItemPudoCodes item={item} wrapper={wrapper} statusEndpoint={pudoLink} displayMode={displayMode} />
  ) : (
    <OrderPudoCodes wrapper={wrapper} statusEndpoint={pudoLink} />
  );
};

export default PudoCodesAutoLoad;
